// InstantMessageNewAttachment - MODULE
// ***********************************************************************************************************************
import * as React from "react";
import { Base } from "../../framework/base";
import { IFileAttachment } from "../../models/common/fileAttachment";

// ChannelInstantMessageNewAttachmentImage
export interface IChannelInstantMessageNewAttachmentImageProp {
    attachment: IFileAttachment;
    selectedId: string;
    onClick: (id: string) => void;
    onDropAttachments: (e: any) => Promise<void>;
    onDragOverAttachments: (e: any) => void;
    onDragEnterAttachments: (e: any) => void;
    onDragLeaveAttachments: (e: any) => void;
}

export class ChannelInstantMessageNewAttachmentImage extends React.Component<IChannelInstantMessageNewAttachmentImageProp, {}> {
    render() {
        const props = this.props;
        const attachment = props.attachment;
        return (
            <div className={"attachmentImage" + (attachment.id === props.selectedId ? " selected" : "")} onClick={() => { props.onClick(attachment.id); }} title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}
                onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>
                <img src={attachment.thumbnail} alt={attachment.name} onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}/>
            </div>
        );
    }
}

// ChannelInstantMessageNewAttachment
export interface IChannelInstantMessageNewAttachmentProp {
    attachment: IFileAttachment;
    selectedId: string;
    onClick: (id: string) => void;
    onDropAttachments: (e: any) => Promise<void>;
    onDragOverAttachments: (e: any) => void;
    onDragEnterAttachments: (e: any) => void;
    onDragLeaveAttachments: (e: any) => void;
}

export class ChannelInstantMessageNewAttachment extends React.Component<IChannelInstantMessageNewAttachmentProp, {}> {
    render() {
        const props = this.props;
        const attachment = props.attachment;
        return (
            <div className={"attachment" + (attachment.id === props.selectedId ? " selected" : "")} onClick={(e) => { e.stopPropagation(); props.onClick(attachment.id); }} title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}
                onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>
                <span className={"icon file file_type_" + attachment.type}
                    onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}></span>
                <span className="name"
                    onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>{attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ")"}</span>
            </div>
        );
    }
}